export enum BackupSymlinkType {
  ignoreSymlinks = 0,
  backupSymlinksOnly = 1,
  backupOriginalFilesInPlaceOfSymlinks = 2,
  backupOriginalFilesInOriginalPlaces = 3,
  backupOriginalFilesInOriginalPlacesPlusSymlinks = 4
}
